import { parseAndFormatDateYMD } from '../../lib/filters';
import React, { useState } from 'react';
import WaiverActions from '../WaiverActions';
import WaiverModal from '../WaiverModal';

export interface Criteria {
  date: string;
  airlineCode?: string;
  flightNumber?: string;
  departureAirportCode?: string;
  arrivalAirportCode?: string;
  firstDepartureDate: string;
  lastDepartureDate: string;
}

interface FlightSpecificCriteriaProps {
  criteria?: Criteria[];
  label: string;
  addButtonLabel: string;
  onChange: (updatedCriteria: Criteria[]) => void;
  readOnly: boolean;
}

const FlightSpecificCriteria: React.FC<FlightSpecificCriteriaProps> = ({
  criteria: initialCriteria = [],
  label,
  addButtonLabel,
  onChange,
  readOnly,
}) => {
  const [criteria, setCriteria] = useState<Criteria[]>(initialCriteria);
  const [modalObj, setModalObj] = useState<{ label: string; name: string; value: string; placeholder?: string; required?: boolean; type?: string }[]>([]);
  const formatDate = (date: string) => parseAndFormatDateYMD(date);
  const [open, setOpen] = useState<boolean>(false);
  const [actionCaller, setActionCaller] = useState<string>('');
  const [criteriaIndex, setCriteriaIndex] = useState<number>();

  const addCriteria = () => {
    setOpen(true);
    openFlightSpecificCriteriaModal('add');
  };

  const removeCriteria = (criteriaToRemove: Criteria) => {
    const updatedCriteria = criteria.filter((filterCriteria) => criteriaToRemove !== filterCriteria);
    setCriteria(updatedCriteria);
    handleChange(updatedCriteria);
  };

  const cloneCriteria = (criteriaToClone: Criteria) => {
    const updatedCriteria = [...criteria, { ...criteriaToClone }];
    setCriteria(updatedCriteria);
    handleChange(updatedCriteria);
  };

  const editCriteria = (criteriaToEdit: Criteria, criteriaIndex: number) => {
    setOpen(true);
    openFlightSpecificCriteriaModal('edit', criteriaToEdit);
    setCriteriaIndex(criteriaIndex);
  };

  const handleChange = (updatedCriteria: Criteria[]) => {
    onChange(updatedCriteria);
  };

  const openFlightSpecificCriteriaModal = (caller: string, flightSpecificCriteria?: Criteria) => {
    const defaultValue = {
      airlineCode: '',
      flightNumber: '',
      departureAirportCode: '',
      arrivalAirportCode: '',
      firstDepartureDate: '',
      lastDepartureDate: '',
      ...flightSpecificCriteria,
    };

    
    setModalObj([
      {
        label: 'Airline',
        name: 'airlineCode',
        value: defaultValue.airlineCode,
        placeholder: 'Example: MU',
        required: true,
      },
      {
        label: 'Flight Number',
        name: 'flightNumber',
        value: defaultValue.flightNumber,
        placeholder: 'Example: 577',
      },
      {
        label: 'Departure Airport',
        name: 'departureAirportCode',
        value: defaultValue.departureAirportCode,
        placeholder: 'Example: LAX',
        required: true,
      },
      {
        label: 'Arrival Airport',
        name: 'arrivalAirportCode',
        value: defaultValue.arrivalAirportCode,
        placeholder: 'Example: SFO',
        required: true,
      },
      {
        label: 'First Departure Date',
        name: 'firstDepartureDate',
        value: defaultValue.firstDepartureDate,
        required: true,
        type: 'date',
      },
      {
        label: 'Last Departure Date',
        name: 'lastDepartureDate',
        value: defaultValue.lastDepartureDate,
        required: true,
        type: 'date',
      }
    ]);

    setActionCaller(caller);
  }

  return (<>
    <div className="form-group mini-section">
      <label>{label}:</label>
      <div className="waiver-item-list section-content">
      {criteria.map((criteriaItem: Criteria, index: number) => (
        <div key={index} className="form-control section-item waiver-item">
        <b>{criteriaItem.airlineCode} {criteriaItem.flightNumber}</b>
        from <b>{criteriaItem.departureAirportCode}</b> to <b>{criteriaItem.arrivalAirportCode}</b>
        (<b>{formatDate(criteriaItem.firstDepartureDate)}</b> to
        <b>{formatDate(criteriaItem.lastDepartureDate)}</b>)
        {!readOnly && (
          <div>
            <a onClick={() => cloneCriteria(criteriaItem)}>Clone</a> |
            <a onClick={() => editCriteria(criteriaItem, index)}>Edit</a> |
            <a onClick={() => removeCriteria(criteriaItem)}>Delete</a>
          </div>
        )}
        </div>
      ))}
      {!readOnly && (
        <button className="btn btn-default waiver-button action-button" type="button" onClick={() => addCriteria()}>
          {addButtonLabel}
        </button>
      )}
      </div>
    </div>
    <WaiverModal className='waiver-add-flight' title={'Add Flight'} isModalOpen={open} fields={modalObj}
      size={'lg'} onCancel={() => setOpen(false)} submit={(result: any) => {
        setOpen(false);
        if (actionCaller === 'add') {
          const updatedCriteria = criteria ? [...criteria, result] : [result];
          setCriteria(updatedCriteria);
          handleChange(updatedCriteria);
        } else {
          const updatedCriteria = [...criteria];
          if (criteriaIndex !== undefined) {
            updatedCriteria[criteriaIndex] = result;
          }
          setCriteria(updatedCriteria);
          handleChange(updatedCriteria);
        }
      }} />
  </>);
};

export default FlightSpecificCriteria;